import styled from 'styled-components'

type Props = {
	size: number
}

export const Container = styled.div<Props>`
	height: ${({ size }) => size}px;
	width: ${({ size }) => size}px;
	position: relative;
`
